import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import { useTranslation } from 'react-i18next';
import { eventNamesAtom, eventOutcomesAtom } from '@/atoms/queries/eventData';
import { snakeToCamel } from '@/utils/queries';

const unwrappedEventNamesAtom = unwrap(eventNamesAtom);

export const useKgfEventAttributeProps = () => {
  const { t } = useTranslation(['events', 'filters']);
  const eventOptions = useAtomValue(unwrappedEventNamesAtom);
  const eventOutcomes = useAtomValue(eventOutcomesAtom);

  const eventNameOptions = (eventOptions ?? []).map(({ label, options }) => ({
    label: t(`fields.event.group.${snakeToCamel(label)}`, { ns: 'events' }),
    options: options.map(option => ({
      label: t(`fields.event.type.${snakeToCamel(option.label)}`, { ns: 'events' }),
      value: option.value,
    })),
  }));

  const outcomeOptions = eventOutcomes.map(value => ({
    label: t(`fields.event.attributes.outcome.${snakeToCamel(value)}`, { ns: 'events' }),
    value,
  }));

  return {
    eventNameOptions,
    eventNameOptionsLoading: eventOptions === undefined,
    outcomeOptions,
  };
};
